"use client";
import React from "react";
import useOnScreen from "@/src/hooks/useOnScreen";
import { AnimatedMenuItemProps } from "./types";

const AnimatedMenuItem: React.FC<AnimatedMenuItemProps> = ({
  name,
  delay,
  onClick,
}) => {
  const { ref, isIntersecting } = useOnScreen<HTMLLIElement>(0.1, true);

  return (
    <li
      ref={ref}
      className={`transition-transform duration-700 ease-in-out ${
        isIntersecting
          ? "translate-y-0 opacity-100"
          : "-translate-y-10 opacity-0"
      }`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      <button onClick={onClick} className="menu-item">
        {name}
      </button>
    </li>
  );
};

export default AnimatedMenuItem;
